import { createSelector } from 'reselect'
import { toSafeJS } from '../helpers/ImmutableHelper'

const getSupplier = (state) => state.suppliers.get('supplier')
const getAllSupplier = (state) => state.suppliers

export const getSupplierSelector = createSelector([getSupplier], (serviceOrder) => toSafeJS(serviceOrder))
export const getAllSupplierSelector = createSelector([getAllSupplier], (serviceOrder) => toSafeJS(serviceOrder))
